"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SummaryPage = void 0;
var Ceramic = __importStar(require("@amzn/ceramic-jsx"));
var ceramic_jsx_1 = require("@amzn/ceramic-jsx");
var ceramic_components_1 = require("@amzn/ceramic-components");
/**
 * special Grout object which holds the data for row that was clicked. Check out
 * Utils.ts's navigateToDetailsPage method for more details on how this object is created
 * and stored inside Grout context.
 */
var rowData;
/**
 * Page for summary tab displayed on shipmentDetails page.
 * @param props component properties to be passed in this component.
 * @constructor
 */
var SummaryPage = function (props) {
    return (Ceramic.createCeramicElement(ceramic_jsx_1.LinearContainer, __assign({ id: 'SummaryPageContainer', width: 'fill' }, props),
        Ceramic.createCeramicElement(ceramic_jsx_1.Text, { value: "Overview", padding: "10dp", font: { weight: "bold" } }),
        Ceramic.createCeramicElement(ceramic_components_1.SimpleListRow, { label: "Status", value: function () { return rowData.status; } }),
        Ceramic.createCeramicElement(ceramic_components_1.SimpleListRow, { label: "Amazon Id", value: function () { return rowData.amazonId; } }),
        Ceramic.createCeramicElement(ceramic_components_1.SimpleListRow, { label: "Destination", value: function () { return rowData.destination; } }),
        Ceramic.createCeramicElement(ceramic_components_1.SimpleListRow, { label: "Origin", value: function () { return rowData.origin; } }),
        Ceramic.createCeramicElement(ceramic_jsx_1.Text, { value: "Shipment Contents", padding: "10dp", font: { weight: "bold" } }),
        Ceramic.createCeramicElement(ceramic_components_1.SimpleListRow, { label: "MSKUs", value: function () { return rowData.contents; } }),
        Ceramic.createCeramicElement(ceramic_components_1.SimpleListRow, { label: "Units", value: function () { return rowData.units; } })));
};
exports.SummaryPage = SummaryPage;
